export default {"src":"/_next/static/media/0x73968b9a57c6E53d41345FD57a6E6ae27d6CDB2F.9286ee24.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};